export function toQuery(params = {}) {
  if (typeof params === "string") return params.replace("?", "")
  Object.keys(params).forEach(
    (key) => params[key] == null && delete params[key]
  )
  return new URLSearchParams(JSON.parse(JSON.stringify(params))).toString()
}
